import { Component } from '@verndale/core';
import { debounce } from '../helpers/debounce';
class HomepageMasthead extends Component {
  setupDefaults() {
    this.dom = {
      heading: this.el.querySelector<HTMLElement>(
        '.homepage-masthead__heading'
      ),
      links: this.el.querySelector<HTMLElement>('.homepage-masthead__list')
    };

    this.init();
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 100)
    );
  }

  init() {
    this.setLinksClass();
    this.calculateHeadingHeight();
    this.calculateRemainingSpace();
  }

  setLinksClass() {
    if (this.dom.links) {
      (this.dom.heading as HTMLElement)?.classList.add(
        'homepage-masthead__heading--padded'
      );
    }
  }

  calculateRemainingSpace() {
    const height = (this.dom.links as HTMLElement)?.offsetHeight;
    this.el.style.setProperty('--remaining-space', `${height}px`);
  }

  calculateHeadingHeight() {
    let height = (this.dom.heading as HTMLElement).offsetHeight;
    if (this.dom.links) {
      height -= 10;
    }
    this.el.style.setProperty('--heading-height', `${height}px`);
  }

  handleResize() {
    this.calculateHeadingHeight();
    this.calculateRemainingSpace();
  }
}

export default HomepageMasthead;
